import Tippy from '@tippyjs/react';
import PropTypes from 'prop-types';

import { DTIcon } from 'lib/customPropTypes';

import './styles.css';
// eslint-disable-next-line import/no-extraneous-dependencies
import 'tippy.js/dist/tippy.css';

const Tooltip = ({ children, label }) => (
  <Tippy animation="fade" arrow content={label} interactive placement="bottom">
    {/* eslint-disable jsx-a11y/no-noninteractive-tabindex */}
    <span
      className="inline-block text-gray-4 focus:text-gray-6 hover:text-gray-6"
      data-testid="tooltip-span"
      tabIndex="0"
    >
      {children}
    </span>
    {/* eslint-enable jsx-a11y/no-noninteractive-tabindex */}
  </Tippy>
);

Tooltip.propTypes = {
  /**
   * Tooltip trigger. Icon to hover or focus on to show tooltip.
   */
  children: DTIcon.isRequired,
  /**
   * Text within tooltip.
   */
  label: PropTypes.string.isRequired,
};

export default Tooltip;
